type CssHeight = number | string;

export function normalizeCssHeight(value: unknown): string | null {
  if (value == null) return null;

  // Numbers are valid (React inline style treats numbers as px)
  if (typeof value === 'number' && Number.isFinite(value)) {
    return `${value}px`;
  }

  // Strings: trim and verify
  if (typeof value === 'string') {
    const stringValue = value.trim();
    if (!stringValue) return null;

    // Accept plain numeric strings by converting to px (e.g., "26" -> "26px")
    if (!Number.isNaN(Number(stringValue))) {
      return `${Number(stringValue)}px`;
    }

    // Prefer the standards-based check when available
    if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') {
      return CSS.supports('height', stringValue) ? stringValue : null;
    }

    // Fallback for environments without CSS.supports (e.g., jsdom)
    if (typeof document !== 'undefined') {
      const el = document.createElement('div');
      el.style.height = '';
      el.style.height = stringValue;
      return el.style.height ? stringValue : null;
    }

    // Last resort: simple heuristic (very permissive)
    const lengthLike =
      /^(auto|min-content|max-content|fit-content(?:\(.+\))?|calc\(.+\)|min\(.+\)|max\(.+\)|clamp\(.+\)|\d*\.?\d+(px|em|rem|vh|vw|vmin|vmax|svh|lvh|dvh|vi|vb|ch|ex|lh|rlh|cm|mm|in|pt|pc|q|%)|var\(--[A-Za-z0-9_-]+\))$/i;
    return lengthLike.test(stringValue) ? stringValue : null;
  }

  return null;
}

export function isValidCssHeight(value: unknown): value is CssHeight {
  return normalizeCssHeight(value) !== null;
}
